/** @format */

import React, { useState } from "react";
import {
  Container,
  Col,
  Row,
  Card,
  Form,
  Nav,
  TabContent,
  TabPane,
  Button,
  Image,
} from "react-bootstrap";

// img
import BasicInfoForm from "./basic-info-form";
import SocialLinksForm from "./social-links-form";
import AboutForm from "./about-form";
import { Link } from "react-router-dom";

const MyProfileMultipleForm = () => {
  const [show, AccountShow] = useState("A");
  return (
    <>
      <Container>
        <Row>
          <Col sm="12" lg="12">
            <Card>
              <Card.Body className="pt-0">
                <Form id="form-wizard1" className="text-center">
                  <ul id="top-tab-list" className="p-0 row list-inline">
                    <li
                      className={` ${show === "Image" ? "active done" : ""} ${
                        show === "Personal" ? "active done" : ""
                      } ${show === "Account" ? "active done" : ""} ${
                        show === "A" ? "active " : ""
                      } col-lg-4 col-md-6 text-start mb-2 active`}
                      id="account"
                    >
                      <Link to="#">
                        <i class="material-symbols-outlined">import_contacts</i>
                        <span>Contact</span>
                      </Link>
                    </li>
                    <li
                      id="personal"
                      className={` ${show === "Image" ? "active done" : ""} ${
                        show === "Personal" ? "active done" : ""
                      } ${
                        show === "Account" ? "active" : ""
                      } col-lg-4 col-md-6 mb-2 text-start`}
                    >
                      <Link to="#">
                        <i class="material-symbols-outlined">groups</i>
                        <span>Social</span>
                      </Link>
                    </li>
                    <li
                      id="payment"
                      className={` ${show === "Image" ? "active done" : ""} ${
                        show === "Personal" ? "active " : ""
                      } col-lg-4 col-md-6 mb-2 text-start`}
                    >
                      <Link to="#">
                        <i class="material-symbols-outlined">
                          admin_panel_settings
                        </i>
                        <span>Personal</span>
                      </Link>
                    </li>
                  </ul>
                  <fieldset
                    className={`${show === "A" ? "d-block" : "d-none"}`}
                  >
                    <div className="form-card text-start">
                      <AboutForm />
                    </div>
                    <Button
                      variant="success"
                      name="next"
                      className="next action-button float-end mt-3"
                      value="Next"
                      onClick={() => AccountShow("Account")}
                    >
                      Next
                    </Button>
                  </fieldset>
                  <fieldset
                    className={`${show === "Account" ? "d-block" : "d-none"}`}
                  >
                    <div className="form-card text-start">
                      <SocialLinksForm />
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                      <Button
                        variant="light"
                        name="previous"
                        className="previous action-button-previous"
                        value="Previous"
                        onClick={() => AccountShow("A")}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="success"
                        name="next"
                        className="next action-button float-end"
                        value="Next"
                        onClick={() => AccountShow("Personal")}
                      >
                        Next
                      </Button>
                    </div>
                  </fieldset>

                  <fieldset
                    className={`${show === "Personal" ? "d-block" : "d-none"}`}
                  >
                    <div className="form-card text-start">
                      <BasicInfoForm />
                    </div>
                    <Button
                      variant="light"
                      name="previous"
                      className="previous action-button-previous float-start mt-3"
                      value="Previous"
                      onClick={() => AccountShow("Account")}
                    >
                      Previous
                    </Button>
                  </fieldset>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MyProfileMultipleForm;
